import * as getfilesfromsp from "../../actions/student.action";

const initialState = {
    data: []
};

export default function returnstate(state = initialState, action) {
    switch (action.type) {
        case getfilesfromsp.GET_SHAREPOINT_FILES:
            return {
                ...state,
                data: action.payload
            };
        default:
            return state;
    }
}
